import React from 'react'

import { Box, Button, Typography, Divider, makeStyles } from '@material-ui/core'

import constants from 'constants/index'

import * as service from 'service'
import useSnackbar from 'hooks/useSnackbar'
import { Modal } from 'components'
import styles from './styles'

const useStyles = makeStyles(styles)

const DialogReopen = ({
  nonComplianceReport,
  open,
  setOpen = () => {},
  onEvent = () => {},
}) => {
  const snackbar = useSnackbar()
  const classes = useStyles()

  const reopenRNC = async () => {
    try {
      const response = await service.dponet.nonComplianceReports.reopen({
        nonComplianceReportId: nonComplianceReport?.id,
      })
      setOpen(false)

      snackbar.open({ message: response.data.message, variant: 'success' })
      onEvent()
    } catch (err) {
      setOpen(false)
      snackbar.open({ message: err.message, variant: 'error' })
    }
  }

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      className={classes.modal}
      disableAutoFocus
      title="Reabrir RMC"
    >
      <Box>
        <Box m={3}>
          <Typography>
            {nonComplianceReport?.status ===
            constants.nonComplianceReports.RISK_ACCEPTED_STATUS
              ? `O risco foi assumido com a seguinte justificativa "${nonComplianceReport?.residualRisk?.justification}", deseja realmente reabrir o RMC?`
              : 'RMC finalizado com evidência de implementação: Deseja realmente reabrir o RMC?'}
          </Typography>
        </Box>
        <Divider />
        <Box display="flex" justifyContent="flex-start" my={2} mr={2}>
          <Box pl={2} pr={1}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setOpen(false)}
            >
              Cancelar
            </Button>
          </Box>
          <Button onClick={reopenRNC} variant="contained" color="primary">
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default DialogReopen
